import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { numericAlpha, spaceValidator } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { UserService } from '../../services/api-services/user.service';

@Component({
  selector: 'app-low-activity-reason',
  templateUrl: './low-activity-reason.component.html',
  styleUrls: ['./low-activity-reason.component.scss']
})
export class LowActivityReasonComponent {

  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  constructor(public dialogRef: MatDialogRef<LowActivityReasonComponent>,
    private fb: FormBuilder,
    public toast: ToastrService,
    public shippingService: ShippingService,
    public formService: FormService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    public userService: UserService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
    this.initializeForm();
  }
  initializeForm() {
    this.form = this.fb.group({
      title: new FormControl("", Validators.compose([Validators.required, spaceValidator, numericAlpha])),
    });
  }
  formSubmit() {
    if (this.form.valid) {
      let obj = {
        title: this.form.value.title,
        title_fr: this.form.value.title
      }
      this.isLoading = true;
      this.shippingService.createLowActivityReason(obj).subscribe(res => {
        this.isLoading = false;
        if (res.body.success) {
          this.userService.setValueToShowLowActiveReason(true)
          // this.props.localActivityReason.push(res.body.data);
          this.toast.success(res.body.message);
          // this.formService.addDeliveryPartner.setValue(res.body.data.id);
          this.dialogRef.close();
        }
        else {
          this.toast.error(res.body.message[0]);
        }
      })
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }

}
